import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import formatBytes from '../../common/formatBytes';
export default class CoverEditorModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.maxSize = parseFloat(app.forum.attribute('sycho-profile-cover.max_size') || 2048);
    this.alertAttrs = {
      content: app.translator.trans('sycho-profile-cover.forum.notice', {
        size: formatBytes(this.maxSize * Math.pow(2, 10))
      })
    };
    this.loading = false;
    this.cover = this.attrs.user.cover_thumbnail() || this.attrs.user.cover();
    this.context = '';
  }
  content() {
    let attrs = {};
    let className = 'Modal-image CoverEditor-cover';
    if (this.cover) {
      attrs.style = {
        backgroundImage: "url(".concat(this.cover, ")")
      };
      className += ' CoverEditor-active';
    }
    return [m("div", Object.assign({
      className: className
    }, attrs), this.loading ? m(LoadingIndicator, null) : ''), m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fieldsItems().toArray()))];
  }
  className() {
    return 'Cover-modal Modal--small';
  }
  title() {
    return app.translator.trans('sycho-profile-cover.forum.edit_cover');
  }
  fieldsItems() {
    const items = new ItemList();
    items.add('actions', this.controlItems().toArray());
    return items;
  }
  controlItems() {
    const items = new ItemList();
    items.add('upload', m(Button, {
      icon: "fas fa-upload",
      className: "Button Button--block Button--primary",
      onclick: this.openPicker.bind(this)
    }, app.translator.trans('core.forum.user.avatar_upload_button')));
    items.add('remove', m(Button, {
      icon: "fas fa-times",
      className: "Button Button--block",
      onclick: this.remove.bind(this)
    }, app.translator.trans('core.forum.user.avatar_remove_button')));
    return items;
  }
  openPicker() {
    const input = $('<input type="file">');
    input.appendTo('body').hide().click().on('change', e => {
      this.upload($(e.target)[0].files[0]);
    });
  }
  upload(file) {
    if (this.loading) return;
    const data = new FormData();
    data.append('cover', file);
    this.loading = true;
    this.context = 'added';
    m.redraw();
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(this.attrs.user.id(), "/cover"),
      serialize: raw => raw,
      body: data
    }).then(this.success.bind(this), this.failure.bind(this));
  }
  remove() {
    this.loading = true;
    this.context = 'removed';
    m.redraw();
    app.request({
      method: 'DELETE',
      url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(this.attrs.user.id(), "/cover")
    }).then(this.success.bind(this), this.failure.bind(this));
  }
  success(response) {
    app.store.pushPayload(response);
    this.showAlert('success');
    this.loading = false;
    m.redraw();
    this.hide();
  }
  failure() {
    this.showAlert('error');
    this.loading = false;
    m.redraw();
  }
  showAlert(type) {
    this.alertAttrs.content = app.translator.trans("sycho-profile-cover.forum.".concat(this.context, ".").concat(type));
    this.alertAttrs.type = type;
  }
}
flarum.reg.add('sychoprofile-cover', 'forum/components/CoverEditorModal', CoverEditorModal);